import * as React        from "react"
const pathFormatter = path => (
  <div className='Path'>
    <a href={path} target='_blank'>
      {path.length > 70 ? path.substr(0,67)+"..." : path}
    </a>
  </div>
)
export default pathFormatter
